// TooltipHeader.jsx
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TooltipHeader = ({
  id,
  label,
  tooltip,
  placement = "top",
  colSpan,
  rowSpan,
  className,
  type,
}) => (
  <OverlayTrigger
    placement={placement}
    delay={{ show: 100, hide: 200 }}
    overlay={<Tooltip id={`tooltip-${id}`}>{tooltip}</Tooltip>}
  >
    {type === "td" ? (
      <td className={className} colSpan={colSpan} rowSpan={rowSpan}>
        {label}
      </td>
    ) : (
      <th className={className} colSpan={colSpan} rowSpan={rowSpan}>
        {label}
      </th>
    )}
  </OverlayTrigger>
);

export default TooltipHeader;
